export { default as Card } from './card';
export { default as Head } from './head';
export { default as Paragraph } from './paragraph';
export { default as SubHead } from './subHead';
